export class GlobalConstants {
  //public static emsCompanyTraining: string = "1829";
  //public static crewOther: string = "1670";
  //public static stationOther: string = "1675";
  public static fontName: string = 'Calibri';
  public static fontSize: number = 10;
  public static headingSize: number = 16;
  public static footerFontSize: number = 9;
}
